//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'mint-ui'
import { getText } from "@/axios/util";
import store from '@/store/store'
import {
  getToken,
  setToken,
  removeToken,
  getUserInfo,
  setUserInfo
} from '@/store/getToken'
export default {
  data() {
    return {
      url: this.$route.query.url,
      wechatCode: this.$route.query.wechatCode,
      usernameRules: [{
        validate: (val) => !!val,
        message: '必须填写用户名'
      },
      {
        validate: (val) => val.length >= 3,
        message: '用户名长度大于3'
      }
      ],
      passwordRules: [{
        validate: (val) => !!val,
        message: '必须填写密码'
      }
        //        },
        //        {
        //          validate: (val) => val.length >= 3 && val.length <= 10,
        //          message: '密码长度大于3小于10'
        //        }
      ],
      // argeeRules: [{ validate: (val) => !!val, message: '必须同意用户协议'}],
      validateForm: {
        username: '',
        password: '',
        wechatCode: this.$route.query.wechatCode,
        rememberMe: false,
        autoLogin: false
      }
    }
  },
  methods: {
    submit() {
      var self = this;
      this.$refs.form.validate().then((result) => {
        if (!result) {
          return;
        }
        //登录操作
        this.$store.dispatch('LoginByUsername', this.validateForm).then(data => {
          var loginStatus = store.getters.loginStatus;
          if (loginStatus === 'S') {
            if (self.validateForm.rememberMe || self.validateForm.autoLogin) {
              setUserInfo(self.validateForm);
            }
            var system = {
              win: false,
              mac: false,
              xll: false
            };
            //检测平台
            var p = navigator.platform;
            system.win = p.indexOf("Win") == 0;
            system.mac = p.indexOf("Mac") == 0;
            system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
            //   console.log(system)
            if (system.win || system.mac || system.xll) {

            } else {
              console.log('plus is not defined')
              // document.addEventListener('plusready', function(){
              //微信需要注释以下代码
              plus.navigator.setStatusBarBackground('#6bc9b4');
              plus.navigator.setStatusBarStyle('light');
              plus.navigator.setFullscreen(false);
              // });
            }

            this.$router.app.$options.store.dispatch('GetUserInfo');
            if (this.url != null && this.url != '') {
              this.$router.push({ path: this.url })
            } else {
              this.$router.push({ path: '/' })
            }
          } else {
            Toast({ message: '账号或者密码错误!', duration: 1500, position: 'middle', className: "warning" });
          }
        }).catch(() => {
          Toast({ message: '登录异常!', duration: 1500, position: 'middle', className: "warning" });
        })
      });
    },
  },
  mounted() {
    var userInfo = getUserInfo();
    if (userInfo != null) {
      var rememberMe = userInfo.rememberMe;
      var autoLogin = userInfo.autoLogin;
      if (rememberMe) {
        this.validateForm = userInfo;
        this.validateForm.wechatCode = this.wechatCode;
      }
      if (autoLogin) {
        // this.submit();
      }
    }

    document.addEventListener('plusready', function () {
      var checkUrl = "http://jpt2doc.faujor.com:7070/app/update/version.php?random=" + Math.random();
      var wgtUrl = "http://jpt2doc.faujor.com:7070/app/update/JPT2";
      autoUpdate(checkUrl, wgtUrl);
      var u = navigator.userAgent;
      console.log("终端: " + u);
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      function autoUpdate(checkUrl, wgtUrl) {
        var wgtVer = null;
        // 获取本地应用资源版本号
        plus.runtime.getProperty(plus.runtime.appid, function (inf) {
          console.log("本地资源信息: " + JSON.stringify(inf));
          wgtVer = inf.version;
          console.log("当前应用版本：" + wgtVer);
          checkUpdate()
        });
        // 检测更新
        function checkUpdate() {
          plus.nativeUI.showWaiting("检测更新");
          const xhr = new plus.net.XMLHttpRequest();
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhr.onreadystatechange = function () {
            switch (xhr.readyState) {
              case 4:
                plus.nativeUI.closeWaiting();
                if (xhr.status == 200 || xhr.status == 0) {
                  console.log("检测响应信息：" + JSON.stringify(xhr));
                  console.log("检测更新成功！：" + xhr.responseText);
                  var newVer = xhr.responseText;
                  var arr = newVer.split('-');
                  var isApk = arr[1];
                  newVer = arr[0];
                  if ((wgtVer !== newVer)) {
                    plus.nativeUI.confirm("确定下载更新？", function (e) {
                      if (e.index == 0) {
                        isApk = isApk.replace(/\s*/g, "");
                        console.log("isApk: " + isApk);
                        if (isApk == "false") {
                          wgtUrl = wgtUrl + '-' + newVer + '.wgt';
                          downWgt(wgtUrl);
                        } else {
                          if (isAndroid) {
                            wgtUrl = wgtUrl + '-' + newVer + '.apk';
                            downWgt(wgtUrl);
                          } else {
                            console.log("需要扫码重新下载!");
                            //window.location.href = "https://www.pgyer.com/Gslq"
                            plus.nativeUI.toast("请扫码重新下载！");
                          }
                        }
                      }
                    }, "下载可用更新", ["下载", "取消"]);
                  }
                } else {
                  console.log("检测更新失败！");
                  plus.nativeUI.toast("检测更新失败！");
                }
                break;
              default:
                break;
            }
          }
          xhr.open('GET', checkUrl);
          xhr.send();
        };

        // 下载wgt文件
        function downWgt(wgtUrl12) {
          plus.nativeUI.showWaiting("下载更新");
          console.log(wgtUrl12);
          plus.downloader.createDownload(wgtUrl12, {
            filename: "_doc/update/"
          }, function (d, status) {
            if (status == 200) {
              console.log("下载更新成功：" + d.filename);
              installWgt(d.filename); // 安装wgt资源包
            } else {
              console.log("下载更新失败！");
              plus.nativeUI.toast("下载更新失败！");
            }
            plus.nativeUI.closeWaiting();
          }).start();
        };
        // 更新应用资源
        function installWgt(path) {
          plus.nativeUI.showWaiting("安装更新");
          plus.runtime.install(path, {}, function () {
            plus.nativeUI.closeWaiting();
            console.log("安装更新成功！");
            plus.nativeUI.alert("更新完成！", function () {
              plus.runtime.restart();
            });
          }, function (e) {
            plus.nativeUI.closeWaiting();
            alert("安装更新失败！[" + e.code + "]：" + e.message);
            plus.nativeUI.toast("安装更新失败！");
          });
        };
      }

    })










  }
};



// WEBPACK FOOTER //
// ./src/view/login.vue